import { render, staticRenderFns } from "./DeiFenHuan.vue?vue&type=template&id=3814de27&scoped=true&"
import script from "./DeiFenHuan.vue?vue&type=script&lang=js&"
export * from "./DeiFenHuan.vue?vue&type=script&lang=js&"
import style0 from "./DeiFenHuan.vue?vue&type=style&index=0&id=3814de27&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814de27",
  null
  
)

export default component.exports